class ShelfProductTagCenterController {
    constructor($sce, shelfProductService, analytics) {
        this.$sce = $sce;
        this.shelfProductService = shelfProductService;
        this.analytics = analytics;

        this.product.CentreTag.displayContent = this.getTagContent(this.product.CentreTag);
        this.tag = this.product.CentreTag;
    }

    getTagContent(tag = this.product.CentreTag) {
        return tag.TagType === 'Html'
            ? this.$sce.trustAsHtml(tag.TagContent)
            : tag.TagContent;
    }

    tagClick(event) {
        // addToTrolley or addMultipleToTrolley are not links anymore
        // they prevent the link to follow href
        if (this.shelfProductService.processTrolleyProductTagLink(this.tag.TagLink)) {
            event.preventDefault();
        }
        this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
    }

    htmlTagClick(event) {
        // Same as above, however we need to extract the tag link before processing the link
        const regex = /href="(.*?)"|href='(.*?)'/gm;
        const tagLink = this.tag.TagContent.match(regex);
        if (tagLink && this.shelfProductService.processTrolleyProductTagLink(tagLink[0])) {
            event.preventDefault();
        }
    }

    staticTextOnProductPush() {
        this.analytics.pushEvent('staticTextOnProductFooterClick');
    }

    staticTextClick(event) {
        return this.product.CentreTag.TagType === 'Html'
            ? this.htmlTagClick(event)
            : this.staticTextOnProductPush();
    }
}

const shelfProductTagCenterComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ['$sce', 'ShelfProductService', 'AnalyticsService', ShelfProductTagCenterController],
    template: require('./shelf-product-tag-center.component.html').trim(),
};

module.exports = {
    ShelfProductTagCenterController,
    shelfProductTagCenterComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-tag/shelf-product-tag-center.component.js